/**
 * Create by Alex
 * Description:
 *
 * ------ maintenance history ------
 * 2025/5/14 added to support impacted quick tasks
 */

import { businessConstants } from '../constants/business.constants';

export class ImpactedQuickTaskConfig {
    name: string;
    type: string;
    setting: string;

    /**
     * Parse the impacted quick tasks from response
     * @param serverResponse
     * @returns A array of impacted impacted quick tasks
     */
    static parse(serverResponse, entityId: string): Array<ImpactedQuickTaskConfig> {
        const serverRes = serverResponse['quick-task-definition-list'];
        if (!serverRes) {
            return null;
        }
        const impactedQuickTaskConfig: Array<ImpactedQuickTaskConfig> = new Array<ImpactedQuickTaskConfig>();

        if (serverRes && serverRes.length > 0) {
            serverRes.forEach(item => {
                impactedQuickTaskConfig.push(
                    {
                        name: item.subject,
                        type: businessConstants.impactedConfigType.quickTask,
                        setting: item.field
                    }
                );
            });
        }
        return impactedQuickTaskConfig;
    }
}
